import {useLanguage} from "../configuration/configuration";
import React from "react";
import {TooltipLink} from "./buttons/nav-buttons";
import {getImprintPageUrl, getPrivacyPolicyPageUrl, getTermsOfUsePageUrl} from "../../actions/environment";
import {ChevronRightIcon, fs_small} from "./icons/nav-icons";

// helper for navigation dropdown actions menu
const NavigationLegalDropdown = ({principalUsername}) => {
    const Lang = useLanguage();

    const getPage = (page) => {
        return `/${principalUsername}/page/${page}`
    }

    return <div className="dropdown-menu navbar-actions-dropdown">
        <TooltipLink className="dropdown-item" to={getPage(getImprintPageUrl())}>
            <div className="d-flex align-items-center">
            <ChevronRightIcon size={fs_small} className='ml--2'/>
                <span>{ Lang.nav.header.imprint}</span></div>
        </TooltipLink>

        <TooltipLink className="dropdown-item" to={getPage(getPrivacyPolicyPageUrl())}>
            <div className="d-flex align-items-center">
            <ChevronRightIcon size={fs_small} className='ml--2'/>
                <span>{Lang.nav.header.privacy}</span></div>
        </TooltipLink>

        <TooltipLink className='dropdown-item' to={getPage(getTermsOfUsePageUrl())}>
            <div className="d-flex align-items-center">
            <ChevronRightIcon size={fs_small} className='ml--2'/>
                <span>{Lang.nav.header.terms}</span></div>
        </TooltipLink>
    </div>
}

export default NavigationLegalDropdown;